import React, { useEffect } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import CSSRulePlugin from 'gsap/CSSRulePlugin'

import py from '../img/python.jfif'
import ani from '../img/anime.png'
import css from '../img/css.png'
import javascript from '../img/javscript.png'
import exp from '../img/express.png'
import gsap_ from '../img/gsap.png'
import html from '../img/html.png'
import mongodb from '../img/mongodb.webp'
import node from '../img/node.png'
import react from '../img/react.png'
import parallax from '../img/parallax.png'
import sass from '../img/sass.png'

function Stack() {
    
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger)

        let height = document.querySelector('.motherGallery').clientHeight
        let section1s = gsap.utils.toArray(".gallery:nth-child(1) .gallery-container") 
        let section2s = gsap.utils.toArray(".gallery:nth-child(2) .gallery-container") 
        let container = document.querySelector(".gallery:nth-child(1)")
        let container2 = document.querySelector(".gallery:nth-child(2)")

        var scrollTween = gsap.timeline({
            scrollTrigger: {
                trigger: ".motherGallery",
                pin: true,
                scrub: 0.5,
                end: () => `${height*2}px`,
                // markers:true
            }
        })
        
        scrollTween.to(section1s, {
            xPercent: -100 * (section1s.length - 1),
            ease: "none", // <-- IMPORTANT!
        });

        // scrollTween.to(container, {  backgroundColor: '#000000', ease: "none" }, 0)
        // .to(container, {  backgroundColor: '#ffa500', ease: "none" }, 0)
        
        var scrollTween2 = gsap.timeline({
            scrollTrigger: {
                trigger: ".motherGallery",
                pin: true,
                scrub: 0.5,
                end: () => `${height*2}px`,
                // markers:true
            }
        })
        
        scrollTween2.to(section2s, {
            xPercent: -100 * (1 - section2s.length),
            ease: "none", // <-- IMPORTANT!
        });

        // scrollTween2.to(container2, {  backgroundColor: '#ffa500', ease: "none" }, 0)
        // .to(container2, {  backgroundColor: '#000000', ease: "none" }, 0)
        
        const arrowsColor = document.querySelector('.gallery:nth-child(1) .arrow-left ion-icon')
        const arrows2Color = document.querySelector('.gallery:nth-child(1) .arrow-right ion-icon')
        const arrowsColor2 = document.querySelector('.gallery:nth-child(2) .arrow-left ion-icon')
        const arrows2Color2 = document.querySelector('.gallery:nth-child(2) .arrow-right ion-icon')
        
        var scrollPos = 0 
                
        function onScroll() {
            if ((document.body.getBoundingClientRect()).top > scrollPos) {
                // console.log('Right')
                arrowsColor.style.color = 'orange'
                arrows2Color.style.color = '#fff'
                arrowsColor2.style.color = '#fff'
                arrows2Color2.style.color = 'orange'
            } else {
                // console.log('Left')
                arrows2Color.style.color = 'orange'
                arrowsColor.style.color = '#fff'
                arrowsColor2.style.color = 'orange'
                arrows2Color2.style.color = '#fff'
            
            }
            scrollPos = (document.body.getBoundingClientRect()).top
        }
        window.addEventListener('scroll', onScroll)

    },[])

    return (
        <div className='stacks' id='stacks'>
            <div class="motherGallery">
                <div class="gallery">
                    <div class="gallery-container">
                        <div class="stacks">
                            <div class="hide">
                                <img src={py} alt=""/>
                                <h3>
                                    Python 
                                </h3>
                                <span className='i'> Python </span>
                                <span className='j'> Python </span>
                                <span className='k'> Python </span>
                            </div>
                        </div>
                        <div class="stacks">
                            <div class="hide">
                                <img src={react} alt=""/>
                                <h3>
                                    ReactJS 
                                </h3>
                                <span className='i'> ReactJS </span>
                                <span className='j'> ReactJS </span>
                                <span className='k'> ReactJS </span>
                            </div>
                        </div>
                        <div class="stacks">
                            <div class="hide">
                                <img src={javascript} alt=""/>
                                <h3>
                                    Javascript 
                                </h3>
                                <span className='i'> Javascript </span>
                                <span className='j'> Javascript </span>
                                <span className='k'> Javascript </span>
                            </div>
                        </div>
                    </div>
                    <div class="gallery-container">
                        <div class="stacks">
                            <div class="hide">
                                <img src={mongodb} alt=""/>
                                <h3>
                                    MongoDB 
                                </h3>
                                <span className='i'> MongoDB </span>
                                <span className='j'> MongoDB </span>
                                <span className='k'> MongoDB </span>
                            </div>
                        </div>
                        <div class="stacks">
                            <div class="hide">
                                <img src={node} alt=""/>
                                <h3>
                                    NodeJS 
                                </h3>
                                <span className='i'>  NodeJS  </span>
                                <span className='j'>  NodeJS  </span>
                                <span className='k'>  NodeJS  </span>
                            </div>
                        </div>
                        <div class="stacks">
                            <div class="hide">
                                <img src={exp} alt=""/>
                                <h3>
                                    ExpressJS 
                                </h3>
                                <span className='i'> ExpressJS </span>
                                <span className='j'> ExpressJS </span>
                                <span className='k'> ExpressJS </span>
                            </div>
                        </div>
                    </div>
                    <div class="arrow-left"><ion-icon name="arrow-back-circle-outline"></ion-icon></div>
                    <div class="arrow-right"><ion-icon name="arrow-forward-circle-outline"></ion-icon></div>
                </div>
                <div class="gallery">
                    <div class="gallery-container">
                        <div class="stacks">
                            <div class="hide">
                                <img src={gsap_} alt=""/>
                                <h3>
                                    GSAP 
                                </h3>
                                <span className='i'> GSAP </span>
                                <span className='j'> GSAP </span>
                                <span className='k'> GSAP </span>
                            </div>
                        </div>
                        <div class="stacks">
                            <div class="hide">
                                <img src={parallax} alt=""/>
                                <h3>
                                    Parallax 
                                </h3>
                                <span className='i'> Parallax  </span>
                                <span className='j'> Parallax  </span>
                                <span className='k'> Parallax  </span>
                            </div>
                        </div>
                        <div class="stacks">
                            <div class="hide">
                                <img src={ani} alt=""/>
                                <h3>
                                    AnimeJS 
                                </h3>
                                <span className='i'> AnimeJS </span>
                                <span className='j'> AnimeJS </span>
                                <span className='k'> AnimeJS </span>
                            </div>
                        </div>
                    </div>
                    <div class="gallery-container">
                        <div class="stacks">
                            <div class="hide">
                                <img src={css} alt=""/>
                                <h3>
                                    CSS 
                                </h3>
                                <span className='i'> CSS </span>
                                <span className='j'> CSS </span>
                                <span className='k'> CSS </span>
                            </div>
                        </div>
                        <div class="stacks">
                            <div class="hide">
                                <img src={html} alt=""/>
                                <h3>
                                    HTML5 
                                </h3>
                                <span className='i'> HTML5 </span>
                                <span className='j'> HTML5 </span>
                                <span className='k'> HTML5 </span>
                            </div>
                        </div>
                        <div class="stacks">
                            <div class="hide">
                                <img src={sass} alt=""/>
                                <h3>
                                    SCSS 
                                </h3>
                                <span className='i'> SCSS </span>
                                <span className='j'> SCSS </span>
                                <span className='k'> SCSS </span>
                            </div>
                        </div>
                    </div>
                    <div class="arrow-left"><ion-icon name="arrow-back-circle-outline"></ion-icon></div>
                    <div class="arrow-right"><ion-icon name="arrow-forward-circle-outline"></ion-icon></div>
                </div>
            </div>
        </div>
    )
}

export default Stack